export const getBrowserFingerprint = () => {
    const key = 'br-fp1';
    let fingerprint = localStorage.getItem(key);
    if (!fingerprint) {
        fingerprint = Math.random().toString();
        localStorage.setItem(key, fingerprint);
    }

    return fingerprint;
}
